import { faList } from '@fortawesome/pro-solid-svg-icons/faList'
import { faAdd } from '@fortawesome/pro-solid-svg-icons/faAdd'
import { faUpload } from '@fortawesome/pro-solid-svg-icons/faUpload'
import { useTranslation } from 'react-i18next'
import EmptyStateComponent from 'components/reusables/emptyState'
import { Wrapper } from './styled'

interface IProps {
  addQuestion: () => void
  importQuestions: () => void
}

const EmptyState = ({ addQuestion, importQuestions }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix =
    'administration.blocks.type.questionBankV2.sections.emptyState'

  return (
    <Wrapper>
      <EmptyStateComponent
        title={t(`${translationPrefix}.title`)}
        icon={faList}
        iconSize="small"
        action={addQuestion}
        actionIcon={faAdd}
        actionTitle={t(`${translationPrefix}.actions.addQuestion`)}
        /* secondaryAction={importQuestions}
        secondaryActionIcon={faUpload}
        secondaryActionTitle={t(`${translationPrefix}.actions.importQuestions`)} */
      />
    </Wrapper>
  )
}

export default EmptyState
